var React = require('react');

function MapPin (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z","key":0}),React.createElement("circle",{"cx":"12","cy":"10","r":"3","key":1})]);
}

MapPin.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-map-pin"};

module.exports = MapPin;

MapPin.default = MapPin;
